<template>
  <div class="asc-report-summary">
    <div class="asc-report-summary--item">
      <asc-bar-chart
        title="Count by Platform"
        :values="getModelNameCount.slice(0, 8)"
        series-name="Count"
        category-name="Count"
        :allow-decimals="false"
      ></asc-bar-chart>
    </div>
    <div class="asc-report-summary--item">
      <asc-bar-chart
        title="Count by System"
        :values="getSystemCount.slice(0, 8)"
        series-name="Count"
        category-name="Count"
        :allow-decimals="false"
      ></asc-bar-chart>
    </div>
    <div class="asc-report-summary--item">
      <asc-bar-chart
        title="Count by Report Type"
        :values="getReportTypeCount.slice(0, 8)"
        series-name="Count"
        category-name="Count"
        :allow-decimals="false"
      ></asc-bar-chart>
    </div>
    <div class="asc-report-summary--item">
      <asc-bar-chart
        title="Count by Tail"
        :values="getTailCount.slice(0, 8)"
        series-name="Count"
        category-name="Count"
        :allow-decimals="false"
      ></asc-bar-chart>
    </div>
    <div class="asc-report-summary--item">
      <asc-bar-chart
        title="Count by Report Date"
        :values="getReportDateMonthCount.slice(0, 8)"
        series-name="Count"
        category-name="Count"
        :allow-decimals="false"
      ></asc-bar-chart>
    </div>
  </div>
</template>

<script>
import AscBarChart from '@/components/molecules/AscBarChart'
import _ from 'lodash'

export default {
  name: 'AscReportSummary',

  components: { AscBarChart },

  props: {
    reportData: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    getModelNameCount() {
      const groupedData = _.groupBy(this.reportData, 'modelName')

      return Object.keys(groupedData)
        .map((item, index) => {
          return {
            text: item === 'null' ? 'N/A' : item,
            count: Object.values(groupedData)[index].length,
          }
        })
        .sort((a, b) => b.count - a.count)
    },

    getSystemCount() {
      const groupedData = _.groupBy(this.reportData, 'systemName')

      return Object.keys(groupedData)
        .map((item, index) => {
          return {
            text: item === 'null' ? 'N/A' : item,
            count: Object.values(groupedData)[index].length,
          }
        })
        .sort((a, b) => b.count - a.count)
    },

    getReportTypeCount() {
      const groupedData = _.groupBy(this.reportData, 'reportType')

      return Object.keys(groupedData)
        .map((item, index) => {
          return {
            text: item === 'null' ? 'N/A' : item,
            count: Object.values(groupedData)[index].length,
          }
        })
        .sort((a, b) => b.count - a.count)
    },

    getTailCount() {
      const groupedData = _.groupBy(this.reportData, 'tailNumber')

      return Object.keys(groupedData)
        .map((item, index) => {
          return {
            text: item === 'null' ? 'N/A' : item,
            count: Object.values(groupedData)[index].length,
          }
        })
        .sort((a, b) => b.count - a.count)
    },

    getReportDateMonthCount() {
      const mappedReportData = this.reportData.map(item => {
        const reportDate = new Date(item.reportDate)
        const fullYear = reportDate.getFullYear()
        const month = reportDate.toLocaleString('default', { month: 'long' })
        const formattedDate = `${month} ${fullYear}`
        return {
          ...item,
          reportDateMonth: formattedDate,
        }
      })
      const groupedData = _.groupBy(mappedReportData, 'reportDateMonth')

      return Object.keys(groupedData)
        .map((item, index) => {
          return {
            text: item === 'null' ? 'N/A' : item,
            count: Object.values(groupedData)[index].length,
          }
        })
        .sort((a, b) => b.count - a.count)
    },
  },
}
</script>

<style lang="scss">
.asc-report-summary {
  overflow-x: auto;
  max-height: 600px;

  .asc-report-summary--item {
    margin-bottom: 8px;

    .asc-label {
      margin-bottom: 4px;
      display: inline-block;
    }
  }
}
</style>
